import React, { Component } from 'react'
import { motion, AnimatePresence } from 'framer-motion'

const CATEGORIES = [
	{
		id: 'equipment',
		labelKey: 'cat_equipment',
		type: 'intervention',
		color: 'bg-blue-50 text-blue-600',
		icon: (
			<svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
				<path strokeLinecap="round" strokeLinejoin="round" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
			</svg>
		),
	},
	{
		id: 'plumbing',
		labelKey: 'cat_plumbing',
		type: 'intervention',
		color: 'bg-indigo-50 text-indigo-600',
		icon: (
			<svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
				<path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" /><path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
			</svg>
		),
	},
	{
		id: 'leak',
		labelKey: 'cat_leak',
		type: 'intervention',
		color: 'bg-cyan-50 text-cyan-600',
		icon: (
			<svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
				<path strokeLinecap="round" strokeLinejoin="round" d="M12 3c-4.418 0-8 5.373-8 9a8 8 0 0016 0c0-3.627-3.582-9-8-9z" />
			</svg>
		),
	},
	{
		id: 'gas',
		labelKey: 'cat_gas',
		type: 'intervention',
		color: 'bg-red-50 text-red-600',
		icon: (
			<svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
				<path strokeLinecap="round" strokeLinejoin="round" d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z" /><path strokeLinecap="round" strokeLinejoin="round" d="M9.879 16.121A3 3 0 1012.015 11L11 14H9c0 .768.293 1.536.879 2.121z" />
			</svg>
		),
	},
	{
		id: 'broken',
		labelKey: 'cat_broken',
		type: 'intervention',
		color: 'bg-orange-50 text-orange-600',
		icon: (
			<svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
				<path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
			</svg>
		),
	},
	{
		id: 'question',
		labelKey: 'general_question',
		type: 'message',
		color: 'bg-slate-50 text-slate-600',
		icon: (
			<svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
				<path strokeLinecap="round" strokeLinejoin="round" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
			</svg>
		),
	},
]

class NewMessage extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			conversation: null,
			messages: [],
			context: null,
			inputText: '',
			loading: false,
			showTyping: false,
		}
		this.scrollRef = React.createRef()
		this.pollTimer = null
		this.typingTimeout = null
		this.typingStartedAt = null
		this.lastMessageSync = 0
	}

	get conversationId() {
		return this.props.match.params.conversation
	}

	componentDidMount() {
		this.props.updateShell(null, true, this.props.history.location.pathname, true)
		if (this.conversationId)
			this.loadConversation()
		this.pollTimer = setInterval(this.pollMessages, 5000)
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.messages.length !== this.state.messages.length || prevState.context !== this.state.context)
			this.scrollToBottom()
	}

	componentWillUnmount() {
		if (this.pollTimer)
			clearInterval(this.pollTimer)
		if (this.typingTimeout)
			clearTimeout(this.typingTimeout)
	}

	computeLastSync = (messages) => {
		let last = 0
		for (let i = 0; i < messages.length; i++)
		{
			if (messages[i].created_time && messages[i].created_time > last)
				last = messages[i].created_time
		}
		return last
	}

	loadConversation = () => {
		this.props.fetchConversationByID(this.conversationId)
		.then(conversation => {
			this.props.fetchMessagesByConversation(conversation._id)
			.then(messages => {
				this.lastMessageSync = this.computeLastSync(messages)
				this.setState({ conversation, messages, context: conversation.type }, this.scrollToBottom)
				if (conversation.read_guest === false)
					this.props.postConversationReadGuest(conversation._id).catch(err => console.log(err))
			})
			.catch(err => console.log(err))
		})
		.catch(err => console.log(err))
	}

	_startTyping = () => {
		if (this.typingTimeout)
			clearTimeout(this.typingTimeout)
		this.typingStartedAt = Date.now()
		this.typingTimeout = setTimeout(() => {
			this.typingTimeout = null
			this.typingStartedAt = null
			this.setState({ showTyping: false })
		}, 6000)
		this.setState({ showTyping: true })
	}

	_stopTyping = () => {
		if (this.typingTimeout)
		{
			clearTimeout(this.typingTimeout)
			this.typingTimeout = null
		}
		this.typingStartedAt = null
		this.setState({ showTyping: false })
	}

	pollMessages = () => {
		if (!navigator.onLine)
			return ;
		if (!this.conversationId || this.state.loading)
			return ;
		this.props.pollMessagesByConversation(this.conversationId, this.lastMessageSync)
		.then(incoming => {
			if (!incoming || incoming.length === 0)
				return ;
			const elapsed = this.typingStartedAt ? Date.now() - this.typingStartedAt : 1500
			const delay = Math.max(0, 1500 - elapsed)
			setTimeout(() => {
				this._stopTyping()
				this.props.postConversationReadGuest(this.conversationId).catch(err => console.log(err))
				this.setState(prev => {
					const existing = {}
					for (let i = 0; i < prev.messages.length; i++)
						existing[prev.messages[i]._id] = true
					const merged = prev.messages.slice()
					for (let i = 0; i < incoming.length; i++)
					{
						if (!existing[incoming[i]._id])
							merged.push(incoming[i])
					}
					merged.sort((a, b) => (a.created_time || 0) - (b.created_time || 0))
					return { messages: merged }
				}, () => {
					this.lastMessageSync = this.computeLastSync(this.state.messages)
				})
			}, delay)
		})
		.catch(() => {})
	}

	scrollToBottom = () => {
		if (this.scrollRef.current)
			this.scrollRef.current.scrollTop = this.scrollRef.current.scrollHeight
	}

	selectContext = (categoryId) => {
		this.setState({ context: categoryId })
	}

	handleInput = (event) => {
		this.setState({ inputText: event.target.value })
	}

	handleSubmit = (event) => {
		event.preventDefault()
		const text = this.state.inputText.trim()
		if (!text || this.state.loading)
			return
		if (!this.conversationId)
			this.createAndSend(text)
		else
			this.sendMessage(text)
	}

	createAndSend = (text) => {
		const category = CATEGORIES.find(c => c.id === this.state.context)
		this.setState({ loading: true })
		const conversation = {
			user: this.props.user._id,
			title: this.props.lang_assets.messages[category.labelKey],
			type: category.type,
		}
		this.props.postSubmitConversation(conversation)
		.then(conv => {
			const message = {
				conversation: conv._id,
				user: this.props.user._id,
				message: text,
			}
			return this.props.postSubmitMessage(message)
			.then(msg => ({ conv, msg }))
		})
		.then(({ conv, msg }) => {
			this.lastMessageSync = this.computeLastSync([msg])
			this.setState({
				inputText: '',
				loading: false,
				conversation: conv,
				messages: [msg],
			})
			if (msg.auto_reply_sent)
				this._startTyping()
			this.props.history.replace(`/nouveau-message/${conv._id}`)
		})
		.catch(err => {
			console.log(err)
			this.setState({ loading: false })
		})
	}

	sendMessage = (text) => {
		this.setState({ loading: true })
		const message = {
			conversation: this.state.conversation._id,
			user: this.props.user._id,
			message: text,
		}
		this.props.postSubmitMessage(message)
		.then(msg => {
			if (msg.auto_reply_sent)
			{
				this.setState(prev => {
					const merged = prev.messages.concat(msg).sort((a, b) => (a.created_time || 0) - (b.created_time || 0))
					return { inputText: '', loading: false, messages: merged }
				}, () => {
					this.lastMessageSync = this.computeLastSync(this.state.messages)
					this.scrollToBottom()
				})
				this._startTyping()
				return
			}
			this.setState({ inputText: '', loading: false })
			return this.props.fetchMessagesByConversation(this.state.conversation._id)
			.then(messages => {
				this.lastMessageSync = this.computeLastSync(messages)
				this.setState({ messages }, this.scrollToBottom)
			})
		})
		.catch(err => {
			console.log(err)
			this.setState({ loading: false })
		})
	}

	formatTime = (timestamp) => {
		const time = new Date(timestamp * 1000)
		let hours = time.getHours()
		let minutes = time.getMinutes()
		if (hours < 10) hours = '0' + hours
		if (minutes < 10) minutes = '0' + minutes
		return hours + ':' + minutes
	}

	render() {
		const { conversation, messages, context, inputText, loading, showTyping } = this.state
		const { theme, lang_assets } = this.props
		const t = lang_assets.messages
		const themeColor = '#' + theme.color1
		const showWizard = !this.conversationId && !context
		const canSend = inputText.trim().length > 0 && (context !== null || this.conversationId) && !loading
		return (
			<div className="flex flex-col h-screen bg-white">
				<header className="px-4 border-b border-slate-100 flex items-center h-24 sticky top-0 bg-white z-20 shadow-sm relative">
					<button
						onClick={() => this.props.history.push('/messages')}
						className="p-2 -ml-1 rounded-full text-slate-600 relative z-10"
						style={{ backgroundImage: 'none', backgroundColor: 'transparent' }}
					>
						<svg width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
							<path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
						</svg>
					</button>
					<div className="absolute inset-0 flex items-center justify-center pointer-events-none">
						<h2 className="font-bold text-slate-800 text-lg leading-tight px-12 text-center truncate">
							{conversation ? conversation.title : t.new_message}
						</h2>
					</div>
				</header>

				<div ref={this.scrollRef} className="flex-1 overflow-y-auto px-4 pt-5 pb-3 bg-white">

					{/* Message de bienvenue */}
					<div className="flex items-end gap-2 mb-3">
						<div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 text-xs font-bold text-white" style={{ backgroundColor: themeColor }}>
							A
						</div>
						<div style={{ maxWidth: '72%' }}>
							<div className="px-4 py-3 rounded-2xl rounded-bl-sm text-sm leading-relaxed text-slate-800" style={{ backgroundColor: '#EFEFEF' }}>
								{t.welcome}
							</div>

							{showWizard && (
								<motion.div
									initial={{ opacity: 0, scale: 0.95 }}
									animate={{ opacity: 1, scale: 1 }}
									className="mt-2 bg-white rounded-2xl overflow-hidden border border-slate-200"
								>
									<div className="px-4 py-3 border-b border-slate-100">
										<p className="font-semibold text-slate-700 text-sm">{t.wizard_title}</p>
									</div>
									<div className="divide-y divide-slate-100">
										{CATEGORIES.map((cat) => (
											<button
												key={cat.id}
												onClick={this.selectContext.bind(this, cat.id)}
												className="w-full flex items-center px-4 py-3 hover:bg-slate-50 text-left"
												style={{ backgroundImage: 'none', backgroundColor: 'transparent' }}
											>
												<div className={`p-1.5 rounded-lg ${cat.color} mr-3 flex-shrink-0`}>
													{cat.icon}
												</div>
												<span className="flex-1 text-slate-700 text-sm">{t[cat.labelKey]}</span>
												<svg width="14" height="14" className="text-slate-300 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
													<path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
												</svg>
											</button>
										))}
									</div>
								</motion.div>
							)}

							{!showWizard && context && (
								<motion.div
									initial={{ opacity: 0, y: 4 }}
									animate={{ opacity: 1, y: 0 }}
									className="mt-2 px-4 py-3 rounded-2xl rounded-bl-sm text-sm leading-relaxed text-slate-800"
									style={{ backgroundColor: '#EFEFEF' }}
								>
									{t.category_ack.replace('{subject}', t[(CATEGORIES.find(c => c.id === context) || {}).labelKey] || (conversation ? conversation.title : ''))}
								</motion.div>
							)}
						</div>
					</div>

					{/* Messages de la conversation */}
					<AnimatePresence initial={false}>
						{messages.map((msg, id) => {
							const isGuest = !!msg.user
							return (
								<motion.div
									key={msg._id || id}
									initial={{ opacity: 0, y: 8, scale: 0.97 }}
									animate={{ opacity: 1, y: 0, scale: 1 }}
									transition={{ duration: 0.15 }}
									className={`flex items-end gap-2 mt-3 ${isGuest ? 'justify-end' : 'justify-start'}`}
								>
									{!isGuest && (
										<div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 text-xs font-bold text-white" style={{ backgroundColor: themeColor }}>
											A
										</div>
									)}
									<div className={`flex flex-col gap-0.5 ${isGuest ? 'items-end' : 'items-start'}`} style={{ maxWidth: '72%' }}>
										<div
											className={`px-4 py-3 text-sm leading-relaxed ${isGuest ? 'rounded-2xl rounded-br-sm text-white' : 'rounded-2xl rounded-bl-sm text-slate-800'}`}
											style={isGuest ? { backgroundColor: themeColor } : { backgroundColor: '#EFEFEF' }}
										>
											{msg.message}
											<p className="text-xs font-thin text-slate-600 px-1">
												{this.formatTime(msg.created_time)}
											</p>
										</div>
									</div>
									{isGuest && <div className="w-0 flex-shrink-0" />}
								</motion.div>
							)
						})}
					</AnimatePresence>

					{/* Bulle "..." — accusé de réception en cours */}
					<AnimatePresence>
						{showTyping && (
							<motion.div
								key="typing-indicator"
								initial={{ opacity: 0, y: 8 }}
								animate={{ opacity: 1, y: 0 }}
								exit={{ opacity: 0, y: 4 }}
								transition={{ duration: 0.2 }}
								className="flex items-end gap-2 mt-3"
							>
								<div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 text-xs font-bold text-white" style={{ backgroundColor: themeColor }}>
									A
								</div>
								<div className="px-4 py-3.5 rounded-2xl rounded-bl-sm flex items-center gap-1.5" style={{ backgroundColor: '#EFEFEF' }}>
									{[0, 0.2, 0.4].map((delay, i) => (
										<motion.span
											key={i}
											animate={{ y: [0, -3, 0] }}
											transition={{ duration: 0.8, repeat: Infinity, delay, ease: 'easeInOut' }}
											style={{ display: 'inline-block', width: 5, height: 5, borderRadius: '50%', backgroundColor: '#94a3b8' }}
										/>
									))}
								</div>
							</motion.div>
						)}
					</AnimatePresence>
				</div>

				<div className="px-4 pt-3 pb-8 bg-white border-t border-slate-100">
					<form
						onSubmit={this.handleSubmit}
						className="flex items-center gap-3"
					>
						<input
							type="text"
							disabled={showWizard}
							value={inputText}
							onChange={this.handleInput}
							placeholder={showWizard ? t.pick_subject_first : t.textarea_placeholder}
							className="flex-1 px-5 py-3.5 rounded-full bg-slate-50 border border-slate-200 text-sm focus:outline-none placeholder:text-slate-400"
						/>
						<button
							type="submit"
							disabled={!canSend}
							className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0"
							style={{
								backgroundImage: 'none',
								backgroundColor: canSend ? themeColor : '#D1D5DB',
							}}
						>
							<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
								<line x1="22" y1="2" x2="11" y2="13" />
								<polygon points="22 2 15 22 11 13 2 9 22 2" fill="white" stroke="none" />
							</svg>
						</button>
					</form>
				</div>
			</div>
		)
	}
}

export default NewMessage
